import { render, staticRenderFns } from "./CardPaketNew.vue?vue&type=template&id=e25aacfe&"
import script from "./CardPaketNew.vue?vue&type=script&lang=js&"
export * from "./CardPaketNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports